import moment, { Moment, MomentInput } from "moment";
import { DateFormat, DateTimeNow, MONTHS } from "../constants/constants";

const addUTCCharater = (value: string) => {
    if (value && value.includes('Z')) {
        return value;
    }
    return value + 'Z';
}

const convertServerToViewFormat = (value: string | undefined | null): string => {
    if (!value) {
        return "";
    }
    return moment(addUTCCharater(value)).format(DateFormat.view);
}

const convertServerToViewDateTimeFormat = (value: string | undefined | null): string => {
    if (!value) {
        return "";
    }
    return moment(addUTCCharater(value)).format(DateFormat.dateTimeView);
}

const convertServerToReviewDateTimeFormat = (value: string | undefined | null): string => {

    if (!value) {
        return "";
    }

    if (value === DateTimeNow) {
        return moment().format(DateFormat.review);
    }

    return moment(addUTCCharater(value)).format(DateFormat.review);
}

const convertServerToMonthViewFormat = (value: string | undefined | null): string => {
    if (!value) {
        return "";
    }
    return moment(value).format(DateFormat.monthView);
}

const convertServerToDatePicker = (value: string | undefined | null) => {
    if (!value) {
        return undefined;
    }
    return moment(addUTCCharater(value), DateFormat.server)
}

const convertDatePickerToServerFormat = (value: Moment | undefined) => {

    if (value === null) {
        return null;
    }

    if (!value) {
        return undefined;
    }

    return value.format(DateFormat.server);
}

const getRelativeTime = (value: string | undefined) => {
    if (!value) {
        return "";
    }

    moment(value).fromNow();
}

const convertMonthName = (value: number | undefined) => {
    const m = MONTHS.find(p => p.value === value);
    if (m) {
        return m.name;
    }

    return "";
}

const convertMonthYearFormat = (month: number | undefined, year: number | undefined) => {
    const m = convertMonthName(month);
    if (!month && !year) {
        return "";
    }
    return `${m}, ${year}`;
}

const currentDate = () => {
    return moment().format(DateFormat.view);
}

const format = (date: MomentInput, format: string) => {
    return moment(date).format(format);
}

export const DATE_UTIL = {
    convertServerToViewFormat,
    convertServerToDatePicker,
    convertDatePickerToServerFormat,
    convertServerToMonthViewFormat,
    convertServerToViewDateTimeFormat,
    getRelativeTime,
    convertMonthName,
    convertMonthYearFormat,
    convertServerToReviewDateTimeFormat,
    CurrentDate: currentDate,
    format
}